import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IRendicontazioniState } from './rendicontazione';

const rendicontazioniStateSelector = createFeatureSelector<IRendicontazioniState>('rendicontazioni');

export const selectRendicontazioni = createSelector(
  rendicontazioniStateSelector,
  (state: IRendicontazioniState) => state.rendicontazioni
);
